/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import { FlexBox, FlexBoxDirection, RadioButton, RadioButtonDomRef, Text, Ui5CustomEvent } from '@ui5/webcomponents-react';
import { useDispatch } from 'react-redux';
import { actions } from '../../store/Products';
import { useEffect, useState } from 'react';
import * as storageUtils from '../../utils/storageUtils';
import { useTranslations } from '../../hooks/useTranslations';
import TaskTitle from '@/components/TaskTitle/TaskTitle';
import { useAppSelector } from '@/hooks';
import TaskIcon from '@/components/TaskIcon';

const backupUserId = 'UNKNOWN_USER';
const BestPracticeTemplateForSourcing: React.FC<any> = ({ content }) => {
    const personalizationValue = content.personalizationConfiguration?.configurationValue;
    const dispatch = useDispatch();
    const [userInfo, setUserInfo] = useState<any>();
    const productList = useAppSelector(state => state.productList);
    const { t } = useTranslations();

    const handleChange = (event: Ui5CustomEvent<RadioButtonDomRef, never>) => {
        dispatch(
            actions.setCurrentProductConfigKeys({
                key: content.productConfigurationKey,
                value: 'bestPracticeTemplateForSourcing',
            })
        );
        dispatch(
            actions.setCurrentProductConfigurationValue({
                productRunId: productList.currentRunId,
                taskId: content.id,
                configurationKey: content.productConfigurationKey,
                configurationValue: event?.target?.value === 'true',
                createdBy: userInfo ? userInfo.user_uuid : backupUserId,
                updatedBy: userInfo ? userInfo.user_uuid : backupUserId,
                personalizationConfiguration: content.personalizationConfiguration,
            })
        );
    };
    useEffect(() => {
        storageUtils.getItem('user') && setUserInfo(storageUtils.getItem('user'));
        dispatch(
            actions.setCurrentProductConfigKeys({
                key: content.productConfigurationKey,
                value: 'bestPracticeTemplateForSourcing',
            })
        );
        dispatch(
            actions.setCurrentProductConfigurationValue({
                productRunId: productList.currentRunId,
                taskId: content.id,
                configurationKey: content.productConfigurationKey,
                configurationValue: null,
                createdBy: userInfo ? userInfo.user_uuid : backupUserId,
                updatedBy: userInfo ? userInfo.user_uuid : backupUserId,
                personalizationConfiguration: content.personalizationConfiguration,
            })
        );
    }, []);

    return (
        <div className="content__datacontroller">
            <TaskIcon icon="ppt-attachment" />
            <TaskTitle />
            <Text data-testid="best-practice-template-title">{t('BEST_PRACTICE_TEMPLATE_QUESTION')}</Text>
            <FlexBox direction={FlexBoxDirection.Column}>
                <RadioButton
                    name="bestPracticeTemplateForSourcing"
                    data-testid="yes-radio-button"
                    text="Yes"
                    value={'true'}
                    onChange={handleChange}
                    checked={personalizationValue === 'true'}
                />
                <RadioButton
                    name="bestPracticeTemplateForSourcing"
                    data-testid="no-radio-button"
                    text="No"
                    value={'false'}
                    onChange={handleChange}
                    checked={personalizationValue === 'false'}
                />
            </FlexBox>
        </div>
    );
};

export default BestPracticeTemplateForSourcing;
